<template>
  <div class="h-100">
    <div class="content-page pr-3 pl-3 pt-2 pb-2 h-100">
      <div class="row h-100">
        <div class="col-2 mh-100">
          <div class="h-100 bg-white">
            <div class="row table2_header" style="margin: 0">
              <div
                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pt-0 pb-0 pr-0 pl-0"
                style="bottom: 3px"
              >
                <div class="pretty p-svg p-curve inc-title">
                  <input
                    type="checkbox"
                    v-model="IsInResigneUser"
                    v-on:change="selectInResigneUser()"
                  />
                  <v-checkbox
                    class="ads-checkbox m-0 p-0"
                    color="indigo darken-3"
                    v-model="IsInResigneUser"
                    hide-details
                    v-on:change="selectInResigneUser()"
                    :label="t.t(dictEnum.LBL_IncludeResignUser)"
                  ></v-checkbox>
                </div>
              </div>
              <div
                class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pt-0 pb-0 pr-0 pl-0t"
              >
                <!-- <font-awesome-icon
                  icon="plus"
                  style="cursor: pointer"
                  v-if="hasRight('AlwWrite')"
                  @click="initUser"
                /> -->
                <div class="search-wrapper">
                  <input
                    type="text"
                    id="search-box"
                    :placeholder="t.t(dictEnum.LBL_SearchStaff)"
                    v-model="staffId"
                  />
                </div>
              </div>
            </div>
            <div class="overflow-y-auto treeview-height">
              <v-treeview
                :items="filteredUserTree"
                item-key="StaffID"
                dense
                :open.sync="treeViewOpen"
                open-all
                open-on-click
                @update:active="editUser"
              >
                <template v-slot:label="{ item }">
                  <div style="cursor: pointer" @click="editUser(item)">
                    {{
                      user.Lang == "EN"
                        ? `${item.EngName} ${item.EngLastName} ( ${
                            item.StaffID
                          } )`
                        : `${item.ChiLastName}${item.ChiName} ( ${
                            item.StaffID
                          } )`
                    }}
                  </div>
                </template>
              </v-treeview>
            </div>
          </div>
        </div>
        <div class="col-8 mh-100">
          <div class="h-100 bg-white font-weight-bold">
            <div class="tab-pane active table-responsive color-table h-90">
              <div class="row table2_header" style="margin: 0">
                <div class="col-sm-5 pt-0 pb-0 pr-0 pl-0">
                  <span>{{ t.t(dictEnum.LBL_UserProfile) }}</span>
                </div>
              </div>
              <div>
                <div class="col-lg-12 pr-4 pl-4 pt-0 pb-0">
                  <div>
                    <b-row class="inputRow">
                      <b-col sm="12" class="text-center">
                        <button
                          style="width: 100px"
                          type="button"
                          class="btn btn-transparent py-0 pl-0 pr-0"
                          :disabled="userIsResigned"
                          @click="userImgClick"
                        >
                          <v-file-input
                            class="d-none"
                            id="userImg"
                            accept="image/*"
                            chips
                            v-on:change="onFileChange"
                            truncate-length="15"
                          ></v-file-input>
                          <b-avatar
                            size="80px"
                            v-if="userImg"
                            :src="`data:image/jpg;base64,${selectedUser.Photo}`"
                            class="img-fluid w-70 rounded-circle"
                          />
                          <b-avatar
                            size="80px"
                            v-else
                            src="../../../static/images/user-pics.png"
                            class="img-fluid w-70 rounded-circle"
                          />
                        </button>
                        <!-- <input
                          type="file"
                          id="userImg"
                          :disabled="userIsResigned"
                          accept="image/png, image/jpeg, image/jpg"
                          @change="onFileChange"
                          style="display: none"
                        /> -->
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="userId">
                          {{ this.t.t(dictEnum.LBL_ID) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="userId"
                          name="userId"
                          maxlength="10"
                          :disabled="true"
                          v-model="selectedUser.StaffID"
                          size="sm"
                          v-validate="'required'"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('userId')"
                          class="text-danger"
                          :title="vErrors.first('userId')"
                        >
                          {{ vErrors.first("userId") }}
                        </span>
                      </b-col>

                      <b-col sm="2">
                        <label for="badgeNum">
                          {{ this.t.t(dictEnum.LBL_StaffBadge) }}:
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="badgeNum"
                          maxlength="30"
                          :disabled="userIsResigned"
                          v-model="selectedUser.BadgeNum"
                          size="sm"
                        ></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="userName">
                          {{ this.t.t(dictEnum.LBL_EngName) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="userNameEng"
                          name="userNameEng"
                          maxlength="50"
                          :disabled="userIsResigned"
                          v-model="selectedUser.EngName"
                          size="sm"
                          v-validate="'required'"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('userNameEng')"
                          class="text-danger"
                          :title="vErrors.first('userNameEng')"
                        >
                          {{ vErrors.first("userNameEng") }}
                        </span>
                      </b-col>
                      <b-col sm="2">
                        <label for="userEngLastName">
                          {{ this.t.t(dictEnum.LBL_LastName) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="userEngLastName"
                          name="userEngLastName"
                          maxlength="50"
                          :disabled="userIsResigned"
                          v-model="selectedUser.EngLastName"
                          size="sm"
                          v-validate="'required'"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('userEngLastName')"
                          class="text-danger"
                          :title="vErrors.first('userEngLastName')"
                        >
                          {{ vErrors.first("userEngLastName") }}
                        </span>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="userName">
                          {{ this.t.t(dictEnum.LBL_ChiName) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="chiName"
                          name="chiName"
                          maxlength="50"
                          :disabled="userIsResigned"
                          v-model="selectedUser.ChiName"
                          size="sm"
                          v-validate="'required'"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('chiName')"
                          class="text-danger"
                          :title="vErrors.first('chiName')"
                        >
                          {{ vErrors.first("chiName") }}
                        </span>
                      </b-col>
                      <b-col sm="2">
                        <label for="userChiName">
                          {{ this.t.t(dictEnum.LBL_LastName) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="chiLastName"
                          name="chiLastName"
                          maxlength="50"
                          :disabled="userIsResigned"
                          v-model="selectedUser.ChiLastName"
                          size="sm"
                          v-validate="'required'"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('chiLastName')"
                          class="text-danger"
                          :title="vErrors.first('chiLastName')"
                        >
                          {{ vErrors.first("chiLastName") }}
                        </span>
                      </b-col>
                    </b-row>
                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="pass">
                          {{ this.t.t(dictEnum.LBL_Password) }}:
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-input
                          id="pass"
                          name="pass"
                          maxlength="50"
                          type="password"
                          :disabled="userIsResigned"
                          v-model="selectedUser.Pwd"
                          size="sm"
                          v-validate="{
                            required: mode == 'new'
                          }"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('pass')"
                          class="text-danger"
                          :title="vErrors.first('pass')"
                        >
                          {{ vErrors.first("pass") }}
                        </span>
                      </b-col>
                      <b-col sm="2">
                        <label for="newPass">
                          {{ this.t.t(dictEnum.LBL_ConfirmNewPw) }}:
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="newPass"
                          name="newPass"
                          maxlength="50"
                          type="password"
                          :disabled="userIsResigned"
                          v-model="selectedUser.ConfirmPwd"
                          size="sm"
                          v-validate="{
                            required: mode == 'new',
                            is: selectedUser.Pwd
                          }"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('newPass')"
                          class="text-danger"
                          :title="vErrors.first('newPass')"
                        >
                          {{ vErrors.first("newPass") }}
                        </span>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="mobile">
                          {{ this.t.t(dictEnum.LBL_Mobile) }}:
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-input
                          id="mobile"
                          maxlength="20"
                          :disabled="userIsResigned"
                          v-model="selectedUser.Mobile"
                          size="sm"
                        ></b-form-input>
                      </b-col>
                      <b-col sm="2">
                        <label for="workPhone"
                          >{{ this.t.t(dictEnum.LBL_WorkPhone) }}:</label
                        >
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="workPhone"
                          maxlength="20"
                          :disabled="userIsResigned"
                          v-model="selectedUser.WorkPhone"
                          size="sm"
                        ></b-form-input>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="email">
                          {{ this.t.t(dictEnum.LBL_Email) }}: 
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-input
                          id="email"
                          name="email"
                          maxlength="100"
                          :disabled="userIsResigned"
                          v-model="selectedUser.Email"
                          size="sm"
                        ></b-form-input>
                      </b-col>
                      <b-col sm="2">
                        <label for="language">
                          {{ this.t.t(dictEnum.LBL_Language) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-select
                          id="language"
                          name="language"
                          size="sm"
                          :disabled="userIsResigned"
                          v-model="selectedUser.Lang"
                          :options="langList"
                          value-field="value"
                          :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                          v-validate="'required'"
                        ></b-form-select>
                        <span
                          v-show="vErrors.has('language')"
                          class="text-danger"
                          :title="vErrors.first('language')"
                        >
                          {{ vErrors.first("language") }}
                        </span>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="staffGrade">
                          {{ this.t.t(dictEnum.LBL_StaffGrade) }}: *
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-select
                          id="staffGrade"
                          name="staffGrade"
                          v-model="selectedUser.StaffGrade"
                          :options="staffGradeList"
                          :disabled="userIsResigned"
                          value-field="StaffGrade"
                          size="sm"
                          :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                          v-validate="'required'"
                        ></b-form-select>

                        <span
                          v-show="vErrors.has('staffGrade')"
                          class="text-danger"
                          :title="vErrors.first('staffGrade')"
                        >
                          {{ vErrors.first("staffGrade") }}
                        </span>
                      </b-col>
                      <b-col sm="2">
                        <label for="jobTitle">
                          {{ this.t.t(dictEnum.LBL_JobTitle) }}: *
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input
                          id="jobTitle"
                          name="jobTitle"
                          maxlength="50"
                          :disabled="true"
                          v-model="selectedUser.JobTitle"
                          size="sm"
                          v-validate="'required'"
                        ></b-form-input>
                        <span
                          v-show="vErrors.has('jobTitle')"
                          class="text-danger"
                          :title="vErrors.first('jobTitle')"
                        >
                          {{ vErrors.first("jobTitle") }}
                        </span>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="acting">
                          {{ this.t.t(dictEnum.LBL_Acting) }}:
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-select
                          id="acting"
                          size="sm"
                          :disabled="userIsResigned"
                          v-model="selectedUser.Acting"
                        >
                          <option
                            v-for="(supervisor,
                            supervisorIndex) in supervisorsList"
                            :key="supervisorIndex"
                            :value="supervisor.StaffID"
                          >
                            {{
                              user.Lang == "EN"
                                ? `${supervisor.EngName} ${
                                    supervisor.EngLastName
                                  }`
                                : `${supervisor.ChiLastName}${
                                    supervisor.ChiName
                                  }`
                            }}
                          </option>
                        </b-form-select>
                      </b-col>
                      <b-col sm="2">
                        <label for="supervisor">
                          {{ this.t.t(dictEnum.LBL_Supervisor) }}:
                        </label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-select
                          id="supervisor"
                          :disabled="userIsResigned"
                          v-model="selectedUser.SupervisorID"
                          ><option value=""></option>
                          <option
                            v-for="(supervisor,
                            supervisorIndex) in supervisorsList"
                            :key="supervisorIndex"
                            :value="supervisor.StaffID"
                          >
                            {{
                              user.Lang == "EN"
                                ? `${supervisor.EngName} ${
                                    supervisor.EngLastName
                                  }`
                                : `${supervisor.ChiLastName}${
                                    supervisor.ChiName
                                  }`
                            }}
                          </option>
                        </b-form-select>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="staffDept">
                          {{ this.t.t(dictEnum.LBL_Department) }}: *
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-select
                          id="staffDept"
                          name="staffDept"
                          v-model="selectedUser.Dept"
                          :options="departmentList"
                          :disabled="userIsResigned"
                          value-field="Dept"
                          size="sm"
                          :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                          @change="selectedUser.TeamCode = ''"
                          v-validate="'required'"
                        ></b-form-select>

                        <span
                          v-show="vErrors.has('staffDept')"
                          class="text-danger"
                          :title="vErrors.first('staffDept')"
                        >
                          {{ vErrors.first("staffDept") }}
                        </span>
                      </b-col>
                      <b-col sm="2">
                        <label for="staffTeam"
                          >{{ this.t.t(dictEnum.LBL_Team) }}:</label
                        >
                      </b-col>
                      <b-col sm="4">
                        <b-form-select
                          id="staffTeam"
                          name="staffTeam"
                          :disabled="userIsResigned"
                          v-model="selectedUser.TeamCode"
                          :options="TeamData"
                          value-field="TeamCode"
                          size="sm"
                          :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                        ></b-form-select>
                      </b-col>
                    </b-row>

                    <b-row class="inputRow">
                      <b-col sm="2">
                        <label for="dateApply">
                          {{ this.t.t(dictEnum.LBL_Status) }}:
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-select
                          id="staffStatus"
                          name="staffStatus"
                          size="sm"
                          :disabled="true"
                          v-model="selectedUser.EmpStatus"
                          :options="statusList"
                          value-field="EmpStatus"
                          :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                          v-validate="'required'"
                        ></b-form-select>
                        <span
                          v-show="vErrors.has('staffStatus')"
                          class="text-danger"
                          :title="vErrors.first('staffStatus')"
                        >
                          {{ vErrors.first("staffStatus") }}
                        </span>
                      </b-col>
                      <b-col sm="2">
                        <label for="dateJoin"
                          >{{ this.t.t(dictEnum.LBL_DateJoin) }}:</label
                        >
                      </b-col>
                      <b-col sm="4">
                        <date-picker
                          id="dateJoin"
                          :disabled="true"
                          :placeholder="this.t.t(dictEnum.LBL_DateJoin)"
                          v-model="selectedUser.DateJoin"
                          :lang="lang"
                          type="date"
                          format="YYYY-MM-DD"
                          v-bind:editable="false"
                          v-bind:clearable="false"
                        ></date-picker>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <b-form-checkbox
                          id="receiveAll"
                          :disabled="userIsResigned"
                          v-model="selectedUser.NotiRef"
                          name="checkbox-1"
                          :value="true"
                        >
                          {{ this.t.t(dictEnum.LBL_ReceiveAllNotification) }}
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">
                        <b-form-checkbox
                          id="rosterBase"
                          :disabled="userIsResigned"
                          v-model="selectedUser.RosterBase"
                          name="checkbox-2"
                          :value="true"
                        >
                          {{ this.t.t(dictEnum.LBL_RosterBase) }}
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <!-- <b-row class="inputRow">
                      <b-col sm="6" v-if="this.mode == 'edit'" class="d-flex">
                        <b-form-checkbox
                          id="userIsResigned"
                          :disabled="userIsResigned"
                          v-model="userIsResigned"
                          name="checkbox-2"
                          :value="true"
                          :unchecked-value="false"
                          @change="changeUserResginDate"
                        >
                        </b-form-checkbox>
                        <label for="dateResign">
                          {{ this.t.t(dictEnum.LBL_Resigned) }}:
                        </label>
                      </b-col>
                    </b-row> -->

                    <b-row class="inputRow">
                      <b-col cols="3">
                        {{ this.t.t(dictEnum.LBL_CheckAttendance) }}:
                      </b-col>
                      <b-col cols="9">
                        <b-row no-gutters>
                          <b-col
                            cols="6"
                            v-for="(dept, deptIndex) in departmentList"
                            :key="deptIndex"
                            class="d-flex align-center"
                          >
                            <b-form-checkbox
                              :disabled="userIsResigned"
                              v-model="selectedUser.DeptsAlw"
                              name="checkbox-2"
                              :value="dept.Dept"
                              :unchecked-value="false"
                            >
                            </b-form-checkbox>
                            <label>
                              {{ user.Lang == "EN" ? dept.EDesc : dept.CDesc }}
                            </label>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
            <div class="h-10">
              <b-col sm="12" class="text-right">
                <button
                  v-if="false"
                  type="button"
                  class="btn btn-danger"
                  @click="DeleteUser"
                >
                  {{ this.t.t(dictEnum.BTN_Delete) }}
                </button>
                <button
                  v-if="
                    hasRight(Settings.Permission.Change, menuId) &&
                      selectedUser.StaffID
                  "
                  type="button"
                  class="btn btn-danger"
                  @click="addOrUpdateUser"
                >
                  {{ this.t.t(dictEnum.BTN_Save) }}
                </button>
              </b-col>
            </div>
          </div>
        </div>
        <div class="col-2">
          <div class="h-100 bg-white font-weight-bold">
            <div class="tab-pane active table-responsive color-table">
              <div class="row table2_header" style="margin: 0">
                <div class="col-sm-5 pt-0 pb-0 pr-0 pl-0">
                  <span>{{ t.t(dictEnum.LBL_UserGrp) }} *</span>
                </div>
              </div>
            </div>

            <div class="p-2">
              <span
                v-show="vErrors.has('UserGrps')"
                class="text-danger"
                :title="vErrors.first('UserGrps')"
              >
                {{ vErrors.first("UserGrps") }}
              </span>
              <b-form-group>
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  name="UserGrps"
                  v-model="selectedUser.UserGrps"
                  :options="userGroupList"
                  :disabled="userIsResigned"
                  :text-field="user.Lang === 'EN' ? 'GrpDesc' : 'ChiDesc'"
                  value-field="UserGrp"
                  stacked
                  v-validate="'required'"
                >
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UserGroupService from "@/service/UserGroupService";
import StaffGradeService from "@/service/StaffGradeService";
import MenuRightSerivce from "@/service/MenuRightService";
import UserService from "@/service/UserService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import TreeNodeHelper from "@/common/helper/TreeNodeHelper";
import ArrayHelper from "@/common/helper/ArrayHelper";
import { User } from "@/model/User";
import { datePickerLang } from "@/constants/globalConstants";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import { Validator } from "vee-validate";
import Settings from "../../constants/Settings";
export default {
  components: {
    DatePicker,
    moment
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userAlias() {
      const userNameArray = this.selectedUser.EngName.split(" ");
      let alias = "";
      for (let i = 0; i < userNameArray.length; i++) {
        alias += userNameArray[i].charAt(0);
      }
      return alias;
    },
    filteredUserTree() {
        let list = this.$data.userList;
        if (this.$data.staffId != "") {
          const filterNode = (node) => {
          const matches = !this.staffId || node.StaffID.includes(this.staffId) || node.name.toLowerCase().includes(this.staffId.toLowerCase());
          if (node.children) {
            const filteredChildren = node.children.map(child => filterNode.call(this, child)).filter(child => child !== null);
            //如果有子节点匹配，也返回当前父节点
             if (filteredChildren.length > 0) {
              return { ...node, children: filteredChildren };
            }
          }
          return matches ? node : null;
        };
        const filterTree = (tree) => {
          return tree.map(node => filterNode(node)).filter(node => node !== null);
        };
        return filterTree(this.userTree);
      }
      const tree = TreeNodeHelper.flattenToTree(
        list,
        "StaffID",
        "children",
        "SupervisorID"
      );
      this.treeViewOpen = tree.map(user => user.StaffID);
      return tree;
  },
    userTree() {
      let list = this.$data.userList;
      if (this.$data.staffId != "") {
        list = list.filter(x =>
          this.wildCardSearch(x, this.$data.staffId.toLowerCase())
        );
      }
      const tree = TreeNodeHelper.flattenToTree(
        list,
        "StaffID",
        "children",
        "SupervisorID"
      );
      this.treeViewOpen = tree.map(user => user.StaffID);
      return tree;
    },
    //userIfResign() {
    //  if (this.$data.selectedUser.DateResign !== "1900-01-01") {
    //    return true;
    //  } else {
    //    return false;
    //  }
    //},
    userImg() {
      return this.$data.selectedUser.Photo ? this.$data.selectedUser.Photo : "";
    },
    supervisorsList() {
      const lang = this.$store.getters[StoreGetter.lang];
      const textKey = lang === "EN" ? "EngName" : "ChiName";
      const selectedUser = this.$data.userList.find(
        x => x.StaffID == this.$data.selectedUser.StaffID
      );
      const allUser = JSON.parse(JSON.stringify(this.$data.userList));
      allUser.sort(ArrayHelper.dynamicSort(textKey));
      // No supervisor
      if (!selectedUser) {
        return allUser;
      } else if (selectedUser && selectedUser.SupervisorID) {
        // With supervisor
        const deepCloneOfUser = JSON.parse(JSON.stringify(this.$data.userList));
        const tree = TreeNodeHelper.flattenToTree(
          deepCloneOfUser,
          "StaffID",
          "children",
          "SupervisorID"
        );
        const root = {
          children: tree
        };
        const editingUserNode = TreeNodeHelper.findNodeInTree(
          root,
          "StaffID",
          this.$data.selectedUser.StaffID,
          "children"
        );
        editingUserNode.children = [];
        let flattenTree = TreeNodeHelper.flatten(tree, "children");
        flattenTree = flattenTree.filter(
          x => x.StaffID !== selectedUser.StaffID
        );
        const users = JSON.parse(JSON.stringify(flattenTree));
        users.sort(ArrayHelper.dynamicSort(textKey));
        return users.filter(
          x =>
            x.StaffID !== selectedUser.StaffID &&
            x.CompCode == selectedUser.CompCode
        );
      } else {
        return allUser.filter(
          x =>
            x.StaffID !== selectedUser.StaffID &&
            x.CompCode == selectedUser.CompCode
        );
      }
    },
    empRefIsEnabled() {
      return true;
    },

    TeamData() {
      let result = [];
      if (this.selectedUser.Dept) {
        result = this.TeamList.filter(x => x.Dept == this.selectedUser.Dept);
      }
      return result;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.UserList,
      treeViewOpen: [],
      Settings: Settings,
      dictEnum: dictEnum,
      staffId: "",
      userList: [],
      staffGradeList: [],
      userGroupList: [],
      langList: [],
      selectedUser: new User(),
      lang: datePickerLang,
      mode: "new",
      IsInResigneUser: false,
      userIsResigned: false,
      departmentList: [],
      TeamList: [],
      statusList: [],
      compList: [],
      selectedComp: ""
    };
  },

  methods: {
    async getTeamList() {
      var obj = {};
      const response = await StaffEmploymentService.getAllTeams(obj);
      if (response.data.IsSuccess) {
        this.TeamList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDepartmentList() {
      var obj = {};
      const response = await StaffEmploymentService.getAllDepartment(obj);
      if (response.data.IsSuccess) {
        this.departmentList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getCompanyList() {
      const obj = {};
      const response = await StaffService.getAllCompany(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffStatusList() {
      var obj = {};
      const response = await StaffEmploymentService.getAllEmployStatus(obj);
      if (response.data.IsSuccess) {
        this.statusList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    initUser() {
      this.selectedUser = new User();
      this.mode = "new";
      this.userIsResigned = false;
      this.vErrors.clear();
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    DeleteUser() {},
    async addOrUpdateUser() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.CFM_Save),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        await this.addOrUpdateUserApiCall();
      }
    },
    wildCardSearch(obj, keyword) {
      if (this.user.Lang == "EN") {
        obj.name = obj["EngName"] + obj["EngLastName"];
      } else {
        obj.name = obj["ChiLastName"] + obj["ChiName"];
      }
      for (const [key, value] of Object.entries(obj)) {
        if (
          JSON.stringify(value)
            .toLowerCase()
            .includes(keyword)
        )
          return true;
      }
      return false;
    },
    async editUser(user) {
      const obj = {
        userId: user.StaffID
      };
      this.mode = "edit";
      const response = await UserService.getUserById(obj);
      if (response.data.IsSuccess) {
        this.selectedUser = response.data.Data;
        this.selectedUser.UserGrps = response.data.Data.UserGrpsList;
        this.userIsResigned = this.selectedUser.EmpStatus != "H";
        this.selectedUser.DateResign = this.selectedUser.DateResign
          ? this.selectedUser.DateResign
          : "";
        this.selectedUser.DeptsAlw = response.data.Data.DeptsAlw
          ? response.data.Data.DeptsAlw.split(",")
          : [];
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
        this.initUser();
      }
    },
    async addOrUpdateUserApiCall() {
      const valid = await this.$validator.validateAll();
      const self = this;
      if (!valid) {
        SweetAlertService.warning(
          "Warn",
          self.t.t(dictEnum.MSG_ValidationFailed)
        );
        return;
      }

      if (this.mode === "new" && !this.selectedUser.Pwd) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Password) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (this.selectedUser.Pwd !== this.selectedUser.ConfirmPwd) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_PasswordNotMatch)
        );
        return;
      }

      if (this.selectedUser.UserGrps.length == 0) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_UserGrp) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      this.selectedUser.DateResign = this.userIsResigned
        ? moment(this.selectedUser.DateResign).format(
            Settings.DateTime.yyyymmdd
          )
        : "1900-01-01";
      const isUserHasChildren = this.userHasChildren();
      if (this.selectedUser.EmpStatus != "H" && isUserHasChildren) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.MSG_ReassignSubordinates)
        );
      } else {
        const obj = {
          model: {
            BadgeNum:this.selectedUser.BadgeNum,
            EngLastName: this.selectedUser.EngLastName,
            EngName: this.selectedUser.EngName,
            ChiLastName: this.selectedUser.ChiLastName,
            ChiName: this.selectedUser.ChiName,
            StaffID: this.selectedUser.StaffID,
            Mobile: this.selectedUser.Mobile,
            WorkPhone: this.selectedUser.WorkPhone,
            EmpRef: this.selectedUser.EmpRef,
            JobTitle: this.selectedUser.JobTitle,
            Lang: this.selectedUser.Lang,
            Email: this.selectedUser.Email,
            StaffGrade: this.selectedUser.StaffGrade,
            // staffselect: this.updatestaffselect,
            Pwd: this.selectedUser.Pwd,
            TeamCode: this.selectedUser.TeamCode,
            Dept: this.selectedUser.Dept,
            SupervisorID: this.selectedUser.SupervisorID,
            DateResign: this.userIsResigned
              ? moment(this.selectedUser.DateResign).format(
                  Settings.DateTime.yyyymmdd
                )
              : "1900-01-01",
            DateJoin: moment(this.selectedUser.DateJoin).format(
              Settings.DateTime.yyyymmdd
            ),
            DateAdd: moment(this.selectedUser.DateAdd).format(
              Settings.DateTime.yyyymmdd
            ),
            UserGrpsList: this.selectedUser.UserGrps,
            Photo: this.selectedUser.Photo,
            EmpStatus: this.selectedUser.EmpStatus,
            ModifyBy: this.$store.getters[StoreGetter.user].UserID,
            AddBy: this.$store.getters[StoreGetter.user].UserID,
            Acting: this.selectedUser.Acting,
            NotiRef: this.selectedUser.NotiRef,
            RosterBase: this.selectedUser.RosterBase,
            DeptsAlw: String(this.selectedUser.DeptsAlw)
          }
        };

        const res =
          this.mode == "new"
            ? await UserService.addUser(obj)
            : await UserService.updateUser(obj);
        if (res.data.IsSuccess) {
          SweetAlertService.success("Success", res.data.Message);
          // if (this.selectedUser.Photo) {
          //   const imageObj = {
          //     ImageBase64String: this.selectedUser.Photo.split(",")[1],
          //     UserID: res.data.Data.StaffID
          //   };
          //   await this.uploadImage(imageObj);
          // }
          this.IsInResigneUser = false;
          await this.getUserList();
        } else {
          SweetAlertService.warning("Warn", res.data.Message);
        }
      }
    },
    selectInResigneUser() {
      var self = this;
      self.getUserList();
    },
    async getUserList() {
      const obj = {
        searchText: "",
        sortField: "",
        isInResigneUser: this.IsInResigneUser
      };
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        this.userList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getStaffGradeList() {
      const obj = {};
      const response = await StaffGradeService.getStaffGrades(obj);
      if (response.data.IsSuccess) {
        this.staffGradeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    userHasChildren() {
      const currUser = this.findUserInTree(this.selectedUser.StaffID);
      if (currUser && currUser.children.length > 0) {
        return true;
      }
      return false;
    },

    findUserInTree(userId) {
      let user = null;
      for (let i = 0; i < this.userList.length; i++) {
        user = this.searchTree(this.userList[i], this.selectedUser.StaffID);
        if (user) {
          break;
        }
      }
      return user;
    },
    searchTree(element, matchingTitle) {
      if (element.StaffID == matchingTitle) {
        return element;
      } else if (element.children != null) {
        let i;
        let result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingTitle);
        }
        return result;
      }
      return null;
    },
    async getLangList() {
      this.langList = [
        { CDesc: "英文", EDesc: "English", value: "EN" },
        { CDesc: "繁體中文", EDesc: "Traditional Chinese", value: "TC" },
        { CDesc: "简体中文", EDesc: "Simplified Chinese", value: "SC" }
      ];
    },
    async getUserGroupList() {
      const obj = {};
      const response = await UserGroupService.getUserGroups(obj);
      if (response.data.IsSuccess) {
        this.userGroupList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async uploadImage(imageObj) {
      const response = await UserService.uploadProfileImage(imageObj);
      if (response.data.IsSuccess) {
        this.getUserList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    userImgClick() {
      document.getElementById("userImg").click(); // Click on the checkbox
    },

    onFileChange(e) {
      let files = e;
      if (
        files.type != "image/jpg" &&
        files.type != "image/jpeg" &&
        files.type != "image/png"
      ) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_PhotoFileType)
        );
        return;
      } else {
        this.createImage(files);
      }
    },
    async changeUserResginDate() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ComfirmResign),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      let date = "1900-01-01";
      let ifResign = false;
      if (result.value) {
        ifResign = await result.value;
        date = moment(new Date()).format(Settings.DateTime.yyyymmdd);
      }
      this.userIsResigned = ifResign;
      this.selectedUser.DateResign = date;
    },
    createImage(file) {
      var self = this;
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function() {
          var image = new Image();
          image.src = reader.result ? reader.result.toString() : "";
          image.onload = function() {
            var path = reader.result ? reader.result.toString() : "";
            self.selectedUser.Photo =
              path.indexOf(",") != -1 ? path.split(",").pop() : "";
          };
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  },

  mounted() {
    this.assignRights();
    this.getUserList();
    this.getTeamList();
    this.getDepartmentList();
    this.getStaffStatusList();
    this.getStaffGradeList();
    this.getLangList();
    this.getUserGroupList();
    const dictonary = {
      custom: {
        userId: {
          required: () => t.t(dictEnum.LBL_ID) + t.t(dictEnum.WARN_IsRequired)
        },
        userNameEng: {
          required: () =>
            t.t(dictEnum.LBL_EngName) + t.t(dictEnum.WARN_IsRequired)
        },
        userEngLastName: {
          required: () =>
            t.t(dictEnum.LBL_LastName) + t.t(dictEnum.WARN_IsRequired)
        },
        chiName: {
          required: () =>
            t.t(dictEnum.LBL_ChiName) + t.t(dictEnum.WARN_IsRequired)
        },
        chiLastName: {
          required: () =>
            t.t(dictEnum.LBL_LastName) + t.t(dictEnum.WARN_IsRequired)
        },
        pass: {
          is: () => t.t(dictEnum.WARN_PasswordNotMatch),
          required: () =>
            t.t(dictEnum.LBL_Password) + t.t(dictEnum.WARN_IsRequired)
        },
        newPass: {
          is: () => t.t(dictEnum.WARN_PasswordNotMatch),
          required: () =>
            t.t(dictEnum.LBL_ConfirmNewPw) + t.t(dictEnum.WARN_IsRequired)
        },
        userChiName: {
          required: () =>
            t.t(dictEnum.LBL_UserChiname) + t.t(dictEnum.WARN_IsRequired)
        },
        jobTitle: {
          required: () =>
            t.t(dictEnum.LBL_JobTitle) + t.t(dictEnum.WARN_IsRequired)
        },
        language: {
          required: () =>
            t.t(dictEnum.LBL_Language) + t.t(dictEnum.WARN_IsRequired)
        },
        email: {
          required: () =>
            t.t(dictEnum.LBL_Email) + t.t(dictEnum.WARN_IsRequired)
        },
        staffGrade: {
          required: () =>
            t.t(dictEnum.LBL_StaffGrade) + t.t(dictEnum.WARN_IsRequired)
        },
        staffStatus: {
          required: () =>
            t.t(dictEnum.LBL_Status) + t.t(dictEnum.WARN_IsRequired)
        },
        staffDept: {
          required: () =>
            t.t(dictEnum.LBL_Department) + t.t(dictEnum.WARN_IsRequired)
        },
        UserGrps: {
          required: () =>
            t.t(dictEnum.LBL_UserGrp) + t.t(dictEnum.WARN_IsRequired)
        }
      }
    };
    Validator.localize("en", dictonary);
  }
};
</script>
<style scoped lang="scss">
.inputRow {
  padding-top: 10px;
}

.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 122px;
  color: #73879c;
  font: 14px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    sans-serif;
}

.pick-panel-date {
  /* width: 200px !important;
  display: block;
  margin: 14px -55px !important; */
  padding: 0;
}

.pick-panel {
  width: 315px !important;
}

.radio input[type="radio"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
}

.checkbox input[type="checkbox"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
  margin-top: inherit;
}
.search-wrapper {
  width: 100px;
  height: 23px;
  line-height: 23px;
  border: 1px solid #fff;
  border-radius: 6px;
  margin-top: -3px;
  padding-left: 6px;
  text-align: right;
  .search-box input {
    // background-color: rgba(255, 255, 255, 0.1) !important;
    width: 90px;
    border: none !important;
    box-shadow: none !important;
    color: grey;
    font-size: 14px;
  }
}

div#event table tr th + th + th {
  width: 100px;
}

.mx-input-append .mx-calendar-icon {
  background-image: url();
  background-position: 50%;
  background-repeat: no-repeat;
}

input#Overseals,
input#Local {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 20px !important;
  height: 24px !important;
}

> .b-form-time-control button {
  padding: 0 !important;
}

> .bi-circle-fill {
  height: 0.5em;
  width: 0.5em;
}

> .selected-date {
  max-width: 100% !important;
}

> .VuePagination__pagination {
  margin: 0px;
}

> .VuePagination__count {
  display: none;
}

> .v-treeview-node__root {
  min-height: 25px;
  cursor: pointer;
}

.overflow-y-auto {
  overflow-y: auto;
}

.treeview-height {
  height: calc(100% - 28px);
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/S060000-Admin/S060100-UserList.vue